import { Box } from '@mui/material';

const SubCoverageIndicator = () => (
  <Box
    sx={{
      width: '0.75rem',
      height: '0.75rem',
      borderLeft: '1.5px solid #bbb',
      borderBottom: '1.5px solid #bbb',
      borderBottomLeftRadius: '4px',
      flexShrink: 0,
      mr: '0.5rem',
    }}
  />
);

export default SubCoverageIndicator;
